/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const CardRetail = (props) => {
  const { inverse, icon, children, imgSrc = '', image, imgAlt, config } = props

  return (
    <div className={resolveProps(props, config, 'CardRetail')}>
      {!!imgSrc && imgSrc ? (
        <div className="mdn-CardRetail-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
      ) : (
        ''
      )}
      <div className="mdn-CardRetail-content">{children}</div>
    </div>
  )
}

export default CardRetail

CardRetail.propTypes = {
  inverse: PropTypes.bool,
  image: PropTypes.bool,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string
}
